import React from "react";
import { Link } from "react-router-dom";
import { heroContent } from "../data/siteData";

export default function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <picture className="hero__picture">
        <source media="(max-width: 640px)" srcSet="/ryu-hero-mobile.jpg" />
        <img
          className="hero__media"
          src="/ryu-hero.jpg"
          alt=""
          fetchPriority="high"
          width="1672"
          height="941"
        />
      </picture>
      <div className="hero__shade" />
      <div className="container hero__inner">
        <p className="hero__kicker">
          <i /> LIQUOR. BUSINESS. BEYOND.
        </p>
        <h1 id="hero-title">
          {heroContent.title.map((line) => (
            <span key={line}>{line}</span>
          ))}
        </h1>
        <div className="hero__lower">
          <p>
            商品をつなぐ。需要をつかむ。
            <br />
            酒類卸売・EC・流通で、ビジネスの次へ。
          </p>
          <div className="hero__actions">
            <a className="button button--brand" href="#business">
              事業内容を見る <span>↗</span>
            </a>
            <Link className="hero__contact" to="/contact">
              お問い合わせ <span>↗</span>
            </Link>
          </div>
        </div>
      </div>
      <div className="hero__bottom">
        <a href="#about">SCROLL TO DISCOVER ↓</a>
        <span>WHOLESALE / E-COMMERCE / DISTRIBUTION</span>
        <small>ブランドイメージ（AI生成）</small>
      </div>
    </section>
  );
}
